module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_moere_og_romsdal_neg.c629ba99.svg";